import React from "react";
import Stack from "@churchofjesuschrist/eden-stack";
import PropTypes from "prop-types";

const SideNavigation = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("nav", rest, /*#__PURE__*/React.createElement(Stack, {
    gapSize: "0"
  }, children));
};

SideNavigation.propTypes = {
  /** Should consist of one or more `NavigationGroup` components to render inside */
  children: PropTypes.node.isRequired
};
export default SideNavigation;